<template>
  <div id="animation_space" :class="`animation animation-${loaded ? 'loaded' : 'wait'} animation-space animation-space-${theme}`">
    <SpaceSvg/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SpaceSvg from '@/components/Animation/SpaceSvg';

export default {
  components: {
    SpaceSvg,
  },

  computed: mapGetters({
    loaded: 'loaded',
    theme: 'theme',
  }),
  watch: {
    theme() {
      clearTimeout(this.disableTimeout);
      if (this.inViewport) {
        this.disableAnimation = false;
        this.checkCurrentTheme();
      } else {
        this.disableTimeout = setTimeout(() => {
          this.disableAnimation = true;
          this.checkCurrentTheme();
        }, 3000);
      }
    },
  },

  props: ['inViewport'],

  data() {
    return {
      timeoutsAnimation: {},
      disableAnimation: false,
      disableTimeout: null,
      timing: 1500,
      orbits: null,
      planets: [],
      saturn: null,
      mechanisms: [],
    };
  },

  mounted() {
    const SVG = window.SVG;

    const space = SVG.select('#space-wrap');
    space.opacity(0);

    if (this.theme === 'dark') {
      this.disableAnimation = true;
      this.timing = 1;
    }

    setTimeout(() => {
      this.disableAnimation = false;
      this.timing = 1500;
      space.animate(200).opacity(1);
    }, 100);


    for (let p = 1; p < 10; p += 1) {
      this.planets.push(SVG.select(`#space-planet-${p}`));
    }
    this.orbits = SVG.select('#space-orbits');
    this.saturn = SVG.select('#space-saturn-circles');
    this.mechanisms = [
      {
        root: SVG.select('#space-red-mechanism'),
        transform: {
          scale: 11.25,
          rotate: -50,
        },
      },
      {
        root: SVG.select('#space-gray-mechanism'),
        transform: {
          scale: 11,
          rotate: 50,
        },
      },
      {
        root: SVG.select('#space-green-mechanism'),
        transform: {
          scale: 3.2,
          rotate: -60,
        },
      },
      {
        root: SVG.select('#space-orange-mechanism'),
        transform: {
          scale: 1.9,
          rotate: 30,
        },
      },
      {
        root: SVG.select('#space-yellow-mechanism'),
        transform: {
          scale: 1.9,
          rotate: 30,
        },
      },
      {
        root: SVG.select('#space-brown-mechanism'),
        transform: {
          scale: 5,
          rotate: -30,
        },
      },
      {
        root: SVG.select('#space-blue-mechanism'),
        transform: {
          scale: 3,
          rotate: -30,
        },
      },
      {
        root: SVG.select('#space-multi-mechanism'),
        transform: {
          scale: 2.3,
          rotate: 28,
        },
      },
      {
        root: SVG.select('#space-upper-mechanism'),
        transform: {
          scale: 8.4,
          rotate: -45,
        },
      },
    ];
    this.checkCurrentTheme();
  },

  methods: {
    checkCurrentTheme() {
      if (this.theme === 'dark') {
        this.darkStatus();
      } else {
        this.whiteStatus();
      }
    },

    whiteStatus() {
      this.disableAnimation = false;
      for (let p = 0; p < this.planets.length; p += 1) {
        const el = this.planets[p];
        this.setTransform(el, 1, 0);
        if (p === this.planets.length - 1) {
          el.animate(100).opacity(1);
        }
      }
      this.setTransform(this.orbits, 1);
      this.setOpacity(this.saturn, 1);
      for (let m = 0; m < this.mechanisms.length; m += 1) {
        const el = this.mechanisms[m];
        this.setTransform(el.root, 1, 0);
      }
    },

    darkStatus() {
      for (let p = 0; p < this.planets.length; p += 1) {
        const el = this.planets[p];
        this.setTransform(el, 0.2, 0);
        if (p === this.planets.length - 1) {
          el.animate(300).opacity(0);
        }
      }
      this.setTransform(this.orbits, 0.6);
      this.setOpacity(this.saturn, 0);
      for (let m = 0; m < this.mechanisms.length; m += 1) {
        const el = this.mechanisms[m];
        this.setTransform(el.root, el.transform.scale, el.transform.rotate);
      }
    },

    setTransform(el, sc, rot) {
      el.animate(this.timing).rotate(rot).transform({
        scaleX: sc,
        scaleY: sc,
      });
    },

    setOpacity(el, op) {
      el.animate(this.disableAnimation ? 0 : this.timing).opacity(op);
    },
  },
};
</script>


<style>

  .animation-space{
    transition: all .3s ease-in-out;
    position: absolute;
    max-width: 550px;
    width: 40vw;
    height: auto;
    opacity: 0;
    top: -4vw;
    right: -3vw;

    @media (min-width: $mediaSmallScreen) {
      top: -1vw;
    }

    &.animation-loaded{
      .page-theme.in-viewport &{
        opacity: 1;
      }
    }

    svg{
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Animation/Space.vue